import React, { useState, useEffect } from "react";
import { getAllCountries,updateOrganizer,changePasswordRequestOtp,changePasswordVerifyOtp,changePasswordCompleteOtp} from "../../../api";
import { colourStyles } from "../../../utils/customSelectStyle";
import { FaFacebookSquare, FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaGlobe } from "react-icons/fa";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import PinInput from "react-pin-input";
import { useNightMode } from "../../../contexts/NightModeContext";
import Background from "../../Login/Background";


const Profile = () => {
  const { isNightMode } = useNightMode();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState<any>([]);
  const [profileData, setProfileData] = useState<any>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const toggle = () => setIsOpen(!isOpen);
  const [activeTab, setActiveTab] = useState("about");
  const [step, setStep] = useState<"request" | "verify" | "reset">("request");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [registrationId, setRegistrationId] = useState<string | null>(null);
  const [timer, setTimer] = useState(0);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const navigate = useNavigate();
  type SocialMediaItem = {
    platform: string;
    url: string;
    };
  const socialIcons: Record<string, string> = {
    facebook: 'fab fa-facebook',
    instagram: 'fab fa-instagram',
    twitter: 'fab fa-twitter',
    youtube: 'fab fa-youtube',
    website: 'fa fa-globe',
    };

  useEffect(() => {
    const organizerData = localStorage.getItem("organizerData");
    if (organizerData) {
        const parsed = JSON.parse(organizerData);
        setProfileData(parsed);
        if (parsed?.email) {
        setEmail(parsed.email);
        }
    }
    }, []);
    useEffect(() => {   
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
        const parsedUser = JSON.parse(authUser);
            setUsername(parsedUser.username);
        }
    }, []);
    const handleRequestOtp = async () => {
        try {
             setIsLoading(true);
             setError("");
             const response = await changePasswordRequestOtp();
             console.log("OTP request response:", response);
             if (response.registrationId) {
               setRegistrationId(response.registrationId);
             }
             setStep("verify");
             setTimer(60);
           } catch (err:any) {
             console.error("Failed to request OTP:", err);
             setError(err.response?.data?.message || "Something went wrong");
           } finally {
             setIsLoading(false);
           }
         };
         const handleResendOtp = async () => {
            try {
                setIsLoading(true);
                setError("");
                const response = await changePasswordRequestOtp();
                console.log("Resend OTP response:", response);

                if (response.registrationId) {
                setRegistrationId(response.registrationId);
                setTimer(60); 
                }
            } catch (err: any) {
                console.error("Failed to resend OTP:", err);
                setError(err.response?.data?.message || "Failed to resend OTP");
            } finally {
                setIsLoading(false);
            }
        };
    useEffect(() => {
    let interval: NodeJS.Timeout;
    if (registrationId && timer > 0) {
        interval = setInterval(() => {
        setTimer((prev) => prev - 1);
        }, 1000);
    }
    return () => clearInterval(interval);
    }, [registrationId, timer]);

    const handleVerifyOtp = async () => {
        try {
        setIsLoading(true);
        setError(null);
        await changePasswordVerifyOtp({ email, otp, registrationId });
        setStep("reset");
        } catch (err: any) {
        setError(err.response?.data?.message || "Invalid OTP");
        } finally {
        setIsLoading(false);
        }
    };

    const handleResetPassword = async () => {
        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        try {
            setIsLoading(true);
            setError(null);
            const response = await changePasswordCompleteOtp({ registrationId, newPassword });
            console.log("Password change response:", response);
            toast.success(response?.message || "Password updated successfully!");
            setActiveTab("about");
            setTimeout(() => {
            localStorage.clear();
            onClickLogout(); 
            }, 1000);

            return response;
        } catch (err: any) {
            setError(err.response?.data?.message || "Failed to update password");
            throw err;
        } finally {
            setIsLoading(false);
        }
        };
        const onClickLogout=()=>{
            localStorage.removeItem('token')
            window.location.href='/login'
        }
  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <ToastContainer autoClose={1500} hideProgressBar={true} />
      <div className="profile-banner">
          <div className="user-dt-block">
              <div className="container">
                  <div className="row">
                      <div className="col-xl-4 col-lg-5 col-md-3">
                          <div className="glass-panel p-4 mt-1">
                                <div className="user-avatar-img">
                                    <img src={profileData?.profilePic} alt=""/>
                                    {/* <div className="avatar-img-btn">
                                        <input type="file" id="avatar-img"/>
                                        <label ><i className="fa-solid fa-camera"></i></label>
                                    </div> */}
                                </div>
                                <div className="user-dts">
                                    <h4 className="user-name">{profileData?.name}<span className="verify-badge"><i className="fa-solid fa-circle-check"></i></span></h4>
                                    <span className="user-email">{profileData?.email}</span>
                                </div>
                                {/* {profileData?.followers && profileData?.following && (
                                <div className="ff-block">
                                    <a><span>{profileData?.followers}</span>Followers</a>
                                    <a><span>{profileData?.following}</span>Following</a>
                                </div>
                                )} */}
                                {profileData?.firstName && (
                                <div className="user-description">
                                    <p>Hey I am  {profileData?.firstName} {profileData?.lastName || ""}</p>
                                </div>
                                )}
                                {/* <div className="user-btns">
                                    <a href="my_organisation_dashboard.html" className="co-main-btn co-btn-width min-width d-inline-block h_40">My Organisation<i className="fa-solid fa-right-left ms-3"></i></a>
                                </div> */}
                                <div className="profile-social-link">
                                    <h6>Find me on</h6>
                                    <div className="social-links">
                                         {profileData?.socialMedia?.map((item: SocialMediaItem, index: number) => (
                                            <a
                                              key={index}
                                              href={item.url}
                                              className="social-link"
                                              title={item.platform}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                               >
                                              <i className={` ${socialIcons[item.platform]}`}></i>
                                              </a>
                                         ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-7 col-md-8">
                            <div className="right-profile">
                                <div className="profile-tabs">
                                   <ul className="nav nav-pills nav-fill p-2 garren-line-tab" id="myTab" role="tablist">
                                        <li className="nav-item">
                                                <button
                                                className={`nav-link ${activeTab === "about" ? "active" : ""}`}
                                                onClick={() => setActiveTab("about")}
                                                > 
                                                <i className="fa-solid fa-circle-info"></i>
                                                About
                                                </button>
                                        </li>
                                        <li className="nav-item">
                                               <button
                                                className={`nav-link ${activeTab === "setting" ? "active" : ""}`}
                                                onClick={() => setActiveTab("setting")}
                                                >
                                                <i className="fa-solid fa-gear"></i> 
                                                Setting
                                                </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="myTabContent">
                                        <div className="tab-pane fade active show" >
                                            {activeTab === "about" && (
                                            <div className="glass-panel p-4 mt-4">
                                                <div className="bp-title position-relative">
                                                    <h4>About</h4>
                                                        <button
                                                        className="main-btn btn-hover ms-auto edit-btn me-3 pe-4 ps-4 h_40"
                                                        onClick={() => navigate("/profile-edit")}
                                                        >
                                                        <i className="fa-regular fa-pen-to-square me-2"></i>
                                                        Edit
                                                        </button>
                                                </div>
                                                <div className="about-details">
                                                    <div className="about-step">
                                                        <h5>{profileData?.name}</h5>
                                                        <span>{profileData?.email}</span>
                                                    </div>
                                                    <div className="about-step">
                                                        <h5>Tell us about yourself and let people know who you are</h5>
                                                        <p className="mb-0">{profileData?.bio}</p>
                                                    </div>
                                                    {/* <div className="about-step">
                                                        <h5>Find me on</h5>
                                                        <div className="social-links">
                                                            {profileData?.socialMedia?.map((item: SocialMediaItem, index: number) => (
                                                                <a
                                                                key={index}
                                                                href={item.url}
                                                                className="social-link"
                                                                title={item.platform}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                >
                                                            <i className={`fab ${socialIcons[item.platform]}`}></i>
                                                                </a>
                                                            ))}
                                                        </div>
                                                    </div> */}
                                                    {profileData?.address && (
                                                    <div className="about-step">
                                                        <h5>Address</h5>
                                                        <p className="mb-0">{profileData?.address || ""}</p>
                                                    </div>
                                                    )}
                                                </div>
                                            </div>
                                            )}
                                        </div>
                                        {activeTab === "setting" && (
                                         <div className="glass-panel p-4 mt-4">
                                            <div className="tab-pane active">
                                            <div className="bp-title">
                                                <h4>Password Settings</h4>
                                            </div>

                                            <div className="password-setting p-4">
                                                <div className="password-des">
                                                <h4>Change password</h4>
                                                <p>
                                                    You can update your password from here.
                                                </p>
                                                </div>
                                                 {error && <p className="text-danger">{error}</p>}
                                                {step === "request" && (
                                                <div>
                                                    <div className="form-group mt-4">
                                                    <label className="form-label">Email*</label>
                                                    <input
                                                        type="email"
                                                        className="form-control h_50"
                                                        placeholder="Enter your registered email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        readOnly
                                                    />
                                                    </div>
                                                    <button
                                                    className="main-btn btn-hover w-100 mt-4"
                                                    onClick={handleRequestOtp}
                                                    disabled={isLoading}
                                                    >
                                                    {isLoading ? "Sending..." : "Send OTP"}
                                                    </button>
                                                </div>
                                                )}

                                               {step === "verify" && (
                                                <div>
                                                    <div className="form-group mt-4">
                                                    <label className="form-label">Enter OTP*</label>
                                                    <PinInput
                                                        length={6}
                                                        secret={false}
                                                        type="numeric"
                                                        inputStyle={{
                                                        width: "40px",
                                                        height: "50px",
                                                        margin: "8px",
                                                        borderRadius: "8px",
                                                        border: "2px solid #ccc",
                                                        fontSize: "20px",
                                                        textAlign: "center",
                                                        }}
                                                        onChange={(value) => setOtp(value)}
                                                        onComplete={(value) => setOtp(value)}
                                                    />
                                                    </div>

                                                    {/* Timer / Resend section */}
                                                    <div className="mt-3 text-center">
                                                    {timer > 0 ? (
                                                        <p className="text-muted">Re-send available in {timer}s</p>
                                                    ) : (
                                                        <p>
                                                        Didn’t receive code?{" "}
                                                        <span
                                                            className="text-primary"
                                                            style={{ cursor: "pointer", fontWeight: "500" }}
                                                            onClick={handleRequestOtp} 
                                                        >
                                                            Resend
                                                        </span>
                                                        </p>
                                                    )}
                                                    </div>

                                                    <button
                                                    className="main-btn btn-hover w-100 mt-4"
                                                    onClick={handleVerifyOtp}
                                                    disabled={isLoading}
                                                    >
                                                    {isLoading ? "Verifying..." : "Verify OTP"}
                                                    </button>
                                                </div>
                                                )}
                                               {step === "reset" && (
                                                <div>
                                                    <div className="form-group mt-4">
                                                    <label className="form-label">New Password*</label>
                                                    <div className="loc-group position-relative">
                                                        <input
                                                        className="form-control h_50"
                                                        type={showNewPassword ? "text" : "password"}
                                                        placeholder="Enter new password"
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                        />
                                                        <span
                                                        className="pass-show-eye"
                                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                                        >
                                                        <i className={showNewPassword ? "fas fa-eye" : "fas fa-eye-slash"}></i>
                                                        </span>
                                                    </div>
                                                    </div>
                                                    <div className="form-group mt-4">
                                                    <label className="form-label">Confirm Password*</label>
                                                    <div className="loc-group position-relative">
                                                        <input
                                                        className="form-control h_50"
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        placeholder="Confirm new password"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        />
                                                        <span
                                                        className="pass-show-eye"
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        >
                                                        <i className={showConfirmPassword ? "fas fa-eye" : "fas fa-eye-slash"}></i>
                                                        </span>
                                                    </div>
                                                    </div>

                                                    <button
                                                    className="main-btn btn-hover w-100 mt-4"
                                                    onClick={handleResetPassword}
                                                    disabled={isLoading}
                                                    >
                                                    {isLoading ? "Updating..." : "Update Password"}
                                                    </button>
                                                </div>
                                                )}

                                            </div>
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
  );
};

export default Profile;

